import isServerSideRendering from './isServerSideRendering';

export default function decodeBase64(base64: string) {
  return isServerSideRendering
    ? Buffer.from(base64, 'base64').toString('utf8')
    : window.atob(base64);
}
